// notificationThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { markNotificationAsRead } from '../Redux/slice/notificationSlice';
import { notificationsApi } from '../Redux/apis/notifications';
import { toast } from 'react-toastify';

// Thunk for marking notifications as read
export const markNotificationsAsReadThunk = createAsyncThunk(
    'notifications/markAsRead',
    async ({ notificationIds }, { dispatch }) => {
        try {
            const result = await dispatch(
                notificationsApi.endpoints.markAllAsRead.initiate({ notificationIds })
            ).unwrap();

            dispatch(markNotificationAsRead({ notificationId: notificationIds[0], type: 'message' }));
        } catch (error) {
            console.error('Failed to mark all notifications as read:', error);
            toast.error('Something went wrong!')
        }
    }
);
